import { NgModule } from '@angular/core';

import { EqualSizeDirective } from './equal-size.directive';
import { EqualSizeContainerDirective } from './equal-size-container.directive';

@NgModule({
  declarations: [EqualSizeDirective, EqualSizeContainerDirective],
  exports: [EqualSizeDirective, EqualSizeContainerDirective],
})
export class EqualSizeModule {}
